function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 83.432,
  cy: 74.46,
  r: 48.041,
  stroke: "#C9D5EB",
  strokeWidth: 3,
  strokeDasharray: "1 5"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#success-tick_svg__filter0_dd)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 83.432,
  cy: 74.459,
  r: 43.216,
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M74.93 73.476l7.518 7.73 8.995-12.438",
  stroke: "#1AC3DA",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M102.967 74.53c0 10.75-8.713 19.534-19.535 19.534-10.751 0-19.535-8.713-19.535-19.535 0-10.751 8.714-19.535 19.535-19.535a19.493 19.493 0 0119.535 19.535z",
  stroke: "#1AC3DA",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M83.432 59.913c8.081 0 14.616 6.535 14.616 14.616s-6.535 14.617-14.616 14.617c-8.08 0-14.616-6.536-14.616-14.617 0-4.708 2.178-8.854 5.621-11.524",
  stroke: "#1AC3DA",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "success-tick_svg__filter0_dd",
  x: 0.216,
  y: 0.243,
  width: 166.433,
  height: 192.433,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 35
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.164931 0 0 0 0 0.218629 0 0 0 0 0.395833 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 17.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.184314 0 0 0 0 0.223529 0 0 0 0 0.352941 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})));

function SvgSuccessTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 193,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgSuccessTick;